import { useEffect, useState } from 'react';
import Hero from './components/Hero';
import Features from './components/Features';
import SpecialEvent from './components/SpecialEvent';
import Products from './components/Products';
import Testimonial from './components/Testimonial';
import EmptySection from './components/EmptySection';
import Footer from './components/Footer';
import Navbar from './components/Navbar';
import EventPromo from './components/EventPromo';
import PaymentModal from './components/PaymentModal';

export default function HomePage() {
  const [scrolled, setScrolled] = useState(false);
  const [showPaymentModal, setShowPaymentModal] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="min-h-screen bg-[#0A0A0A]">
      {showPaymentModal && <PaymentModal onClose={() => setShowPaymentModal(false)} />}
      <Navbar scrolled={scrolled} />
      <Hero onStartClick={() => setShowPaymentModal(true)} />
      <EventPromo />
      <Products />
      <Features />
      <SpecialEvent />
      <Testimonial />
      <EmptySection />
      <Footer />
    </div>
  );
}
